import { AxiosError, AxiosResponse } from "axios"
import ErrorHandler from "./ErrorHandler"
import { api } from "services/api"

type CustomAxios = Promise<{
  status: number
  response?: AxiosResponse
  error?: AxiosError
}>

class ApiEventTypes extends ErrorHandler {
  async filterByProduct(product: string) {
    try {
      const axiosResponse = await api.get(`/event-types`, {
        params: {
          product
        }
      })

      return {
        events: axiosResponse.data,
        status: axiosResponse.status
      }
    } catch (e) {
      return {
        events: [],
        status: this.errorHandler(e)
      }
    }
  }

  async getAll() {
    try {
      const axiosResponse = await api.get("/event-types")

      return {
        events: axiosResponse.data,
        status: axiosResponse.status
      }
    } catch (e) {
      return {
        events: [],
        status: this.errorHandler(e)
      }
    }
  }

  async create(eventType: App.EventTypesRequest): CustomAxios {
    return api.post("/event-types", eventType)
  }

  async updateByKey(eventType: App.EventTypesRequest): CustomAxios {
    return api.patch(`/event-types/${eventType.key}`, eventType)
  }

  async deleteByKey(key: string): CustomAxios {
    try {
      const axiosResponse = await api.delete(`/event-types/${key}`)

      return {
        status: axiosResponse.status,
        response: axiosResponse
      }
    } catch (e) {
      return this.errorHandler(e)
    }
  }

  async getEventTypesOptions(productId: string) {
    try {
      const response = await api.get(`/event-type/options/${productId}`)

      return response.data.data
    } catch (error) {
      return {
        options: [],
        prices: {}
      }
    }
  }

  async updateEventTypeIsPublished(id: string) {
    return api.put(`/event-type/published/${id}`)
  }
}

export default ApiEventTypes
